import React from "react";

const Customer = React.lazy(() => import("./customer"));
const Detail = React.lazy(() => import("./detail"));
const CreateCustomerMain = React.lazy(() => import("./create-customer-main"));

export {
  Customer,
  Detail,
  CreateCustomerMain
};
